import React, { useState } from 'react'
import { useCredentialSets } from '../context/CredentialSetContext'
import { ChevronDown, Settings, Star } from 'lucide-react'
import { CredentialSetManager } from './CredentialSetManager'

export const AccountSwitcher: React.FC = () => {
  const { credentialSets, preferredCredentialSet, setPreferredCredentialSet, loading } = useCredentialSets()
  const [isOpen, setIsOpen] = useState(false)
  const [showManager, setShowManager] = useState(false)

  if (loading) {
    return (
      <div className="px-4 py-2 text-sm text-arcade-dim">
        Loading...
      </div>
    )
  }

  return (
    <>
      {!preferredCredentialSet && credentialSets.length === 0 ? (
        <button
          onClick={() => setShowManager(true)}
          className="px-4 py-2 bg-neon-blue text-dark-900 text-sm rounded-lg hover:bg-neon-blue/80 hover:shadow-[0_0_15px_rgba(0,212,255,0.5)] transition-all"
        >
          Configure IG Credentials
        </button>
      ) : (
        <div className="relative">
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="flex items-center gap-2 px-4 py-2 bg-dark-700 border border-dark-600 rounded-lg hover:border-neon-blue transition-colors"
        >
          {preferredCredentialSet ? (
            <>
              <span
                className={`px-2 py-0.5 rounded-full text-xs font-semibold ${
                  preferredCredentialSet.ig_account_type === 'DEMO'
                    ? 'bg-neon-blue/20 text-neon-blue'
                    : 'bg-neon-green/20 text-neon-green'
                }`}
              >
                {preferredCredentialSet.ig_account_type}
              </span>
              <span className="font-medium text-arcade-text">{preferredCredentialSet.nickname}</span>
            </>
          ) : (
            <span className="text-arcade-dim">Select Credential Set</span>
          )}
          <ChevronDown size={16} className="text-arcade-dim" />
        </button>

        {isOpen && (
          <>
            <div
              className="fixed inset-0 z-10"
              onClick={() => setIsOpen(false)}
            />
            <div className="absolute right-0 mt-2 w-80 bg-dark-800 border border-dark-600 rounded-lg shadow-lg z-20">
              <div className="p-2">
                <div className="px-3 py-2 text-xs font-semibold text-arcade-dim uppercase">
                  Switch Credential Set
                </div>
                {credentialSets.map((credSet) => (
                  <button
                    key={credSet.id}
                    onClick={async () => {
                      await setPreferredCredentialSet(credSet.id)
                      setIsOpen(false)
                    }}
                    className={`w-full flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-dark-700 transition-colors ${
                      preferredCredentialSet?.id === credSet.id ? 'bg-neon-blue/10' : ''
                    }`}
                  >
                    {preferredCredentialSet?.id === credSet.id && (
                      <Star size={16} className="text-neon-orange fill-neon-orange" />
                    )}
                    <span
                      className={`px-2 py-0.5 rounded-full text-xs font-semibold ${
                        credSet.ig_account_type === 'DEMO'
                          ? 'bg-neon-blue/20 text-neon-blue'
                          : 'bg-neon-green/20 text-neon-green'
                      }`}
                    >
                      {credSet.ig_account_type}
                    </span>
                    <div className="flex-1 text-left">
                      <div className="font-medium text-sm text-arcade-text">{credSet.nickname}</div>
                      <div className="text-xs text-arcade-dim">
                        ID: {credSet.id}
                      </div>
                    </div>
                    {preferredCredentialSet?.id === credSet.id && (
                      <div className="w-2 h-2 bg-neon-blue rounded-full" />
                    )}
                  </button>
                ))}
              </div>
              <div className="border-t border-dark-600">
                <button
                  onClick={() => {
                    setShowManager(true)
                    setIsOpen(false)
                  }}
                  className="w-full flex items-center gap-2 px-5 py-3 text-sm text-arcade-muted hover:bg-dark-700 hover:text-neon-blue transition-colors"
                >
                  <Settings size={16} />
                  Manage Credential Sets
                </button>
              </div>
            </div>
          </>
        )}
        </div>
      )}

      {showManager && <CredentialSetManager onClose={() => setShowManager(false)} />}
    </>
  )
}
